export type GetPartnersRequest = {
  cpntId?: string;
  dipByRgn?: string;
  ptnrCd?: string;
  ptnrName?: string;
};
